module.exports = __webpack_public_path__ + "img/logo.e518606e.png";